/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectCarouselByCarouselInfo } from '../storage/carousels';

export default function useCarousel(sourceCarouselId, filters) {
  const carouselSelector = useMemo(
    () => selectCarouselByCarouselInfo({ sourceCarouselId, filters }),
    [filters, sourceCarouselId],
  );
  return useSelector(carouselSelector);
}
